import React from 'react';
import { Link } from 'react-router-dom';

function Navbar({ darkMode, onToggleDarkMode }) {
  return (
    <header className="sticky top-0 z-20 backdrop-blur supports-[backdrop-filter]:bg-white/60 dark:supports-[backdrop-filter]:bg-neutral-900/60 border-b border-neutral-200/60 dark:border-neutral-700/60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2 bg-transparent border-none p-0 cursor-pointer">
            <div className="h-8 w-8 rounded-xl bg-gradient-to-br from-green-500 to-green-700 grid place-items-center text-white font-bold shadow-lg">
              ₹
            </div>
            <span className="text-lg font-bold tracking-tight">
              paisa<span className="text-orange-600">.io</span>
            </span>
          </Link>
          <nav className="flex items-center gap-6">
            <span className="text-sm text-neutral-600 dark:text-neutral-300">EMI Calculator</span>
            <button
              onClick={onToggleDarkMode}
              className="text-xl bg-transparent border-none p-0 cursor-pointer"
              aria-label="Toggle dark mode"
            >
              {darkMode ? '☀️' : '🌙'}
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
